module.exports = __webpack_public_path__ + "img/game1.160083bf.png";